//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {
    // formBox: () => import('../components/formBox')
  },
  data: function data() {
    return {
      treeData: [{
        label: '年假',
        value: '',
        num: 0
      }, {
        label: '事假',
        value: 0,
        num: 0
      }, {
        label: '病假',
        value: 1,
        num: 0
      }, {
        label: '调休假',
        value: 2,
        num: 0
      }, {
        label: '婚假',
        value: 3,
        num: 0
      }, {
        label: '产假',
        value: 4,
        num: 0
      }, {
        label: '陪产假',
        value: 5,
        num: 0
      }, {
        label: '丧假',
        value: 6,
        num: 0
      }],
      total: 0,
      defaultCheckedKeys: [],
      loading: false,
      tableData: [],
      where: {
        page: 1,
        limit: 15,
        types: 1,
        cid: '',
        name: '',
        label: [],
        follows: '',
        time: '',
        salesman_id: ''
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.where.page = 1;
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
    }
  }
};